import React from 'react';
import { Popup, Icon, List } from 'semantic-ui-react';

// Aliases are stored as normalized nameKeys (lowercased). Title-case for display.
const prettyAlias = (s) => String(s || '').replace(/\b\w/g, (m) => m.toUpperCase());

/**
 * MergedNamesHint — a small merge indicator + hover popup listing the variant names that were
 * folded into a character (via the reversible character-merge). Renders NOTHING when the
 * character has no merges, so the common case is visually unchanged. Fed by `character.aliases`
 * (already returned on the marketplace character object).
 *
 * @param {string[]} aliases - the canonical's folded nameKeys
 */
const MergedNamesHint = ({ aliases }) => {
  if (!Array.isArray(aliases) || aliases.length === 0) return null;
  return (
    <Popup
      hoverable
      size="small"
      position="top center"
      trigger={
        <Icon
          name="linkify"
          color="grey"
          size="small"
          style={{ marginLeft: 5, cursor: 'help' }}
          aria-label={`also voices ${aliases.length} merged character${aliases.length === 1 ? '' : 's'}`}
        />
      }
    >
      <Popup.Header style={{ fontSize: '0.9em' }}>Also voices</Popup.Header>
      <Popup.Content>
        <List size="small">
          {aliases.map((a, i) => (
            <List.Item key={i}>{prettyAlias(a)}</List.Item>
          ))}
        </List>
      </Popup.Content>
    </Popup>
  );
};

export default MergedNamesHint;
